// Minimal className joiner — joins truthy class strings with a space.
// Kept in-repo to avoid a `clsx`/`classnames` dependency for the one thing
// we actually need it for: conditionally composing CSS Module classes.
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
